import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/motion";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "ICROPSIA India Pvt Ltd respects your privacy. This policy explains how information shared with us through this website is handled.",
      "Information you submit through our enquiry, partnership and bulk order forms — such as your name, phone number, WhatsApp number, business name and location — is used solely to respond to your enquiry and to communicate about ICROPSIA products and partnership opportunities.",
      "We do not sell, rent or share your personal information with third parties for their marketing purposes. Enquiry details are shared only with the ICROPSIA team responsible for responding to you.",
      "You may request correction or deletion of your submitted information at any time by contacting us at icropsia@gmail.com or +91 80101 56588.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By using this website, you agree to these terms. The content on this website is provided by ICROPSIA India Pvt Ltd for general information about our seed products and partnership opportunities.",
      "Product information, availability and packaging details are subject to change. Technical specifications are published only after verification by the company and may be updated from time to time.",
      "Nothing on this website constitutes a guarantee of crop yield or harvest outcome. Agricultural results depend on many factors beyond seed quality, including weather, soil, and crop management practices.",
      "All brand names, product names and content on this website are the property of ICROPSIA India Pvt Ltd and may not be reproduced without permission.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "The information on this website is provided in good faith by ICROPSIA India Pvt Ltd for general guidance. While we work to keep product information accurate and current, we make no representations or warranties of any kind about completeness or suitability for a specific field or condition.",
      "ICROPSIA does not publish yield guarantees, germination percentages or agronomic specifications unless officially verified. Fields awaiting verification are clearly marked on product pages.",
      "Agricultural outcomes depend on soil, weather, sowing practices and crop management. Farmers should follow the recommendations printed on seed packaging and consult local agricultural experts for field-specific advice.",
      "Articles in the Farm Knowledge section are general educational content and are not a substitute for advice from your local agriculture officer or krishi vigyan kendra.",
    ],
  },
};

export default function Legal({ type }) {
  const page = CONTENT[type] || CONTENT.privacy;
  return (
    <>
      <Seo title={`${page.title} | ICROPSIA India Pvt Ltd`} description={`${page.title} for the ICROPSIA India Pvt Ltd website.`} />
      <section className="pt-40 pb-24 container-site max-w-3xl">
        <Reveal>
          <h1 className="font-display text-4xl font-extrabold tracking-tight text-brand-deep">{page.title}</h1>
          <div className="mt-8 space-y-5">
            {page.body.map((p, i) => (
              <p key={i} className="text-brand-charcoal/70 leading-relaxed">{p}</p>
            ))}
          </div>
          <Link to="/" data-testid="legal-back-home" className="mt-10 inline-block text-brand-gold font-bold hover:text-brand-deep transition-colors">
            ← Back to Home
          </Link>
        </Reveal>
      </section>
    </>
  );
}
